import React, { useState } from 'react';
import { Form, Input, Alert, Typography, Card, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/login.module.scss';
import { AuthAPI } from '../../api/auth-api';

const { Title } = Typography;

const ForgotPassword = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleEmailSubmit = async (values) => {
    const { email } = values;
    if (!email) {
      setError('Molimo unesite email');
      return;
    }

    const { success, message } = await AuthAPI.forgotPassword({ email });

    if (success) {
      setTimeout(() => {
        navigate(`/promenite-sifru?email=${encodeURIComponent(email)}`);
      }, 500);
    } else {
      setError(message);
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <Title className={styles.login__title} level={1}>
              Promenite šifru
            </Title>
            <p className={styles.login__subtitle}>
              Molimo vas da unesete email adresu koja je uneta pri registraciji
              kako bismo vam poslali link za promenu šifre.
            </p>
            <Form layout="vertical" onFinish={handleEmailSubmit}>
              <Form.Item
                label="E-mail"
                name="email"
                rules={[{ required: true, message: 'Unesite email!' }]}
              >
                <Input />
              </Form.Item>

              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              <Form.Item className={styles.login__submit}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn-primary"
                >
                  Pošalji link
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default ForgotPassword;
